import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import { NavLink } from 'react-router-dom';

import pages from "./pages";

/*
 * - Host the links
 * - Be responsible for updating the links’ direction, spacing, and other styling based on the breakpoint/device size
 */
const NavList = ({ onLinkClicked, ...props }) => {
  return (
    <Stack
      gap={3}
      overflow="auto"
      width={{ xs: "150px", sm: "initial" }}
      // When we are on mobile, use columns
      direction={{ xs: "column", sm: "row" }}
      sx={{
        mt: { xs: 3, sm: 0 },
        ml: { xs: 3, sm: 0 },      
      }}

      {...props}
    >
      {pages.map((page) => (
        <Link
          component={NavLink}
          key={page.id}
          to={page.slug}
          onClick={onLinkClicked ?? function noop() { return undefined }}
          sx={{
            color: '#333',
            fontWeight: 500,
            transition: 'color 0.3s ease',
            ":hover": {
              color: '#007bff'
            },
            "&.active": {
              color: '#007bff'
            }
          }}>
          {page.name}
        </Link>
      ))}
    </Stack>
  );
};

export default NavList;
